module.exports = __webpack_public_path__ + "img/cupon.84304760.svg";